/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const settingsArchivedConfig = {
  tableHeaders: [
    {
      key: 'First Name',
      filterTypes: [
        {
          label: 'ContainsCI',
          type: 'text',
          id: 'firstName',
        },
      ],
    },
    {
      key: 'Last Name',
      filterTypes: [
        {
          label: 'ContainsCI',
          type: 'text',
          id: 'lastName',
        },
      ],
    },
    {
      key: 'Email',
      filterTypes: [
        {
          label: 'Contains',
          type: 'text',
          id: 'email',
        },
        {
          label: 'Equal',
          type: 'text',
          id: 'email',
        },
      ],
    },
    {
      key: 'Phone number',
      filterTypes: [
        {
          label: 'ContainsCI',
          type: 'text',
          id: 'primaryContactNo',
        },
        {
          label: 'Equal',
          type: 'text',
          id: 'primaryContactNo',
        },
      ],
    },
    {
      key: 'Policy Number',
      filterTypes: [
        {
          label: 'ContainsCI',
          type: 'text',
          id: 'policyNumber',
        },
        {
          label: 'Equal',
          type: 'text',
          id: 'policyNumber',
        },
      ],
    },
    {
      key: 'Policy Status',
      filterTypes: [
        {
          label: 'In',
          type: 'select',
          id: 'status',
          options: [
            {
              label: 'Canceled',
              value: 'CANCELED',
            },
            {
              label: 'Expired',
              value: 'EXPIRED',
            },
          ],
        },
      ],
    },
  ],
};
